import React from 'react';

import { Text } from '@vimeo/bokeh';
import { IBaseDomElementProps } from '@vimeo/core/types/dom';
import { BokehTooltip } from '@vimeo/live-core/components/bokeh';

import { createInteractionDomName } from '../../../../libs/shared/utils/dom/identifying';

interface IQuestionItemAuthorProps extends IBaseDomElementProps {
  name: string;
}

/**
 * Question title, expected to be single line with ellipses.
 * Covered with tooltip to show full name.
 */
export function QuestionItemAuthor({
  className = createInteractionDomName('question-author-name'),
  name,
}: IQuestionItemAuthorProps) {
  return (
    <BokehTooltip placement={'bottom'} label={name} shouldWrapChildren={false}>
      <Text
        className={className}
        variant={'heading-xs'}
        textOverflow={'ellipsis'}
        whiteSpace={'nowrap'}
        overflow={'hidden'}
        maxWidth={'100%'}
      >
        {name}
      </Text>
    </BokehTooltip>
  );
}
